import { createMongoAbility } from '@casl/ability';

let ANONYMOUS_ABILITY;

function defineAbility() {
    const permissions = JSON.parse(localStorage.getItem('userPermissions'));
    if (permissions) {
        return new createMongoAbility(permissions);
    }

    ANONYMOUS_ABILITY = ANONYMOUS_ABILITY || new createMongoAbility([]);
    return ANONYMOUS_ABILITY;
}

export const userAbility = defineAbility();